import { render, staticRenderFns } from "./DropdownBase.vue?vue&type=template&id=3569f7ba&scoped=true"
import script from "./DropdownBase.vue?vue&type=script&lang=js"
export * from "./DropdownBase.vue?vue&type=script&lang=js"
import style0 from "./DropdownBase.vue?vue&type=style&index=0&id=3569f7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3569f7ba",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fform%2Fdropdown%2FDropdownBase.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports